function CheckDate() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  var currentDate = +new Date;
  var target = 'data-unix-time';
  
  this._timeStamp = $('.js--time-stamp');

  this.init = function() {
    this._checkTime();
  };

  this.initAllReady = function() {};

  this._checkTime = function() {
    this._timeStamp.each(function() {
      var unixTime = $(this).attr(target);
      if (unixTime < currentDate) {
        $(this).addClass('past-item');
      } else {
        $(this).addClass('future-item');
      }
    });
  };
}
